import { useLazyQuery } from "@apollo/client/react";

import { queryDocuments } from "@smart/manage-gql-operations-dom";

export const useLazyLoadMatterItems = () => {
  const [load, { loading }] = useLazyQuery(queryDocuments.matterItems);

  return {
    load: async (variables: { matterId: string }) => {
      const result = await load({ variables });
      return result.data?.matterItems;
    },
    loading,
  };
};
